// eslint-disable-next-line import/no-anonymous-default-export
export default `
type Customer {
    _id,
    name
}
type Query {
    customerList: [Customer]
}
`